module.exports = __webpack_public_path__ + "img/9791158790400.0340bac9.jpg";